module.exports = __webpack_public_path__ + "static/img/report.883f33f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/report.svg
// module id = y1pK
// module chunks = 0